import React, { useEffect, useState } from "react";
import { Box, Grid } from "@material-ui/core";
import AppColor from "utilities/AppColor";
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
// import AppButton from "components/CustomButtons/AppButton";
import { useTranslation } from "react-i18next";
import moment from "moment-timezone";
import {
  fetchDashboard
} from "store/slices/dashboard";
import { useDispatch, useSelector } from "react-redux";
import { getAuthInfo } from "store/slices/auth";
import { SYSTEM_ROLE } from "config/AppConfig";
import { fetchDashboardCompany } from "store/slices/dashboard";
import PeopleIcon from '@material-ui/icons/People';
import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import ItemShowInfo from "./ItemShowInfo";
import BusinessIcon from '@material-ui/icons/Business';
// import { useMedia } from "react-use";
import AppUtil from "utilities/AppUtil";

const styles = {
  container: {
    padding: "1rem",
  },
  title: {
    display: 'flex',
    justifyContent: 'center',
    margin: '0 1rem 0',
    '& h5': {
      color: AppColor.mainColor,
    }
  },
  paper: {
    padding: '5rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    '& span': {
      zIndex: 1,
      color: AppColor.white
    }
  },
  iconShape: {
    position: 'absolute',
    width: '90%',
    height: '90%'
  },
  noteChartRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    margin: 5
  },
  noteChartLabel: {
    margin: '0 20px'
  },
  noteChartColor: {
    width: 50,
    height: 25,
    border: 'solid 1px #ededed'
  },
  noteChartContainer: {
    margin: 20,
    padding: 10,
    width: 'fit-content',
    border: 'solid 1px #000'
  }
};
const colorColumns = {
  threeMonths: '#00b27b',
  sixMonths: '#ff961e',
  oneYear: '#2052b6',
  oneWeek: '#90D26D',
  twoWeeks: '#fdbd1f',
  threeWeeks: '#808836'
}
// const useStyles = makeStyles(styles);

const DashboardPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isMobile = AppUtil.mobileAndTabletCheck();
  const authInfo = useSelector(getAuthInfo);

  const [data3Months, setData3Months] = useState({});
  const [data6Months, setData6Months] = useState({});
  const [data12Months, setData12Months] = useState({});
  const [data1Week, setData1Week] = useState({});
  const [data2Weeks, setData2Weeks] = useState({});
  const [data3Weeks, setData3Weeks] = useState({});
  const [dataAll, setDataAll] = useState({});

  const {
    numberOfBillings,
    numberOfBookings,
    numberOfClients,
    numberOfPayrolls,
    numberOfWorkers,
    numberOfCompanies
  } = dataAll;

  const loadDashboard = async (params) => {
    if (authInfo && authInfo.role === SYSTEM_ROLE.COMPANY && authInfo.companyId) {
      const request = {
        ...params,
        companyId: authInfo.companyId
      }
      const result = await dispatch(fetchDashboardCompany(request));
      if (result.payload) {
        switch (result.payload.months) {
          case '3':
            setData3Months(result.payload);
            break;
          case '6':
            setData6Months(result.payload);
            break;
          case '12':
            setData12Months(result.payload);
            break;
          case 'all':
            setDataAll(result.payload);
            break;
          default:
            break;
        }
        switch (result.payload.weeks) {
          case '1':
            setData1Week(result.payload);
            break;
          case '2':
            setData2Weeks(result.payload);
            break;
          case '3':
            setData3Weeks(result.payload);
            break;
          case 'all':
            setDataAll(result.payload);
            break;
          default:
            break;
        }
      }
    } else {
      const result = await dispatch(fetchDashboard(params));
      if (result.payload) {
        switch (result.payload.months) {
          case '3':
            setData3Months(result.payload);
            break;
          case '6':
            setData6Months(result.payload);
            break;
          case '12':
            setData12Months(result.payload);
            break;
          case 'all':
            setDataAll(result.payload);
            break;
          default:
            break;
        }
      }
    }
  };

  const options = {
    chart: {
      type: 'column'
    },
    title: {
      text: '',
      align: 'center'
    },
    xAxis: {
      categories: [
        t('label.participant'),
        t('label.workerAccounts'),
      ],
      type: 'category',
      labels: {
        style: {
          fontSize: '13px',
          fontFamily: 'Verdana, sans-serif'
        }
      },
      crosshair: true,
      accessibility: {
        description: 'Countries'
      }
    },
    yAxis: {
      min: 0
    },
    plotOptions: {
      column: {
        pointPadding: 0,
        borderWidth: 0
      },
    },
    legend: {
      enabled: false
    },
    series: [
      {
        name: t("label.3months"),
        data: [data3Months.numberOfClients, data3Months.numberOfWorkers],
        color: colorColumns.threeMonths
      },
      {
        name: t("label.6months"),
        data: [data6Months.numberOfClients, data6Months.numberOfWorkers],
        color: colorColumns.sixMonths
      },
      {
        name: t("label.1year"),
        data: [data12Months.numberOfClients, data12Months.numberOfWorkers],
        color: colorColumns.oneYear
      }
    ]
  };

  const options2 = {
    chart: {
      type: 'column'
    },
    title: {
      text: '',
      align: 'center'
    },
    xAxis: {
      categories: [
        t('label.bookings'),
        t('label.payrolls'),
        t('label.billings')
      ],
      type: 'category',
      labels: {
        style: {
          fontSize: '13px',
          fontFamily: 'Verdana, sans-serif'
        }
      },
      crosshair: true,
      accessibility: {
        description: 'Countries'
      }
    },
    yAxis: {
      min: 0
    },
    plotOptions: {
      column: {
        pointPadding: 0,
        borderWidth: 0
      },
    },
    legend: {
      enabled: false
    },
    series: [
      {
        name: t("label.1week"),
        data: [data1Week.numberOfBookings, data1Week.numberOfPayrolls, data1Week.numberOfBillings],
        color: colorColumns.oneWeek
      },
      {
        name: t("label.2weeks"),
        data: [data2Weeks.numberOfBookings, data2Weeks.numberOfPayrolls, data2Weeks.numberOfBillings],
        color: colorColumns.twoWeeks
      },
      {
        name: t("label.3weeks"),
        data: [data3Weeks.numberOfBookings, data3Weeks.numberOfPayrolls, data3Weeks.numberOfBillings],
        color: colorColumns.threeWeeks
      }
    ]
  };

  const adminOptions = {
    chart: {
      type: 'column'
    },
    title: {
      text: '',
      align: 'center'
    },
    xAxis: {
      type: 'category',
      categories: [
        t('label.companiesAccounts')
      ],
      labels: {
        style: {
          fontSize: '13px',
          fontFamily: 'Verdana, sans-serif'
        }
      },
      crosshair: true,
      accessibility: {
        description: 'Countries'
      }
    },
    yAxis: {
      min: 0
    },
    plotOptions: {
      column: {
        pointPadding: 0,
        borderWidth: 0
      }
    },
    legend: {
      enabled: false
    },
    series: [
      {
        name: t("label.3months"),
        data: [data3Months.numberOfCompanies],
        color: colorColumns.threeMonths
      },
      {
        name: t("label.6months"),
        data: [data6Months.numberOfCompanies],
        color: colorColumns.sixMonths
      },
      {
        name: t("label.1year"),
        data: [data12Months.numberOfCompanies],
        color: colorColumns.oneYear
      }
    ]
  };

  useEffect(() => {
    loadDashboard({
      startDate: moment().subtract(3, 'months').format('YYYY/MM/DD'),
      endDate: moment().format('YYYY/MM/DD'),
      months: '3'
    });
    loadDashboard({
      startDate: moment().subtract(6, 'months').format('YYYY/MM/DD'),
      endDate: moment().format('YYYY/MM/DD'),
      months: '6'
    });
    loadDashboard({
      startDate: moment().subtract(12, 'months').format('YYYY/MM/DD'),
      endDate: moment().format('YYYY/MM/DD'),
      months: '12'
    });

    loadDashboard({
      startDate: moment().subtract(1, 'weeks').format('YYYY/MM/DD'),
      endDate: moment().format('YYYY/MM/DD'),
      weeks: '1'
    });
    loadDashboard({
      startDate: moment().subtract(2, 'weeks').format('YYYY/MM/DD'),
      endDate: moment().format('YYYY/MM/DD'),
      weeks: '2'
    });
    loadDashboard({
      startDate: moment().subtract(3, 'weeks').format('YYYY/MM/DD'),
      endDate: moment().format('YYYY/MM/DD'),
      weeks: '3'
    });

    loadDashboard({
      startDate: null,
      endDate: null,
      months: 'all'
    });
  }, []);

  return (
    <Box>
      <Box style={{ padding: `${isMobile ? '0' : '2rem 2rem'}` }}>
        {
          (authInfo.role === SYSTEM_ROLE.SUPER_ADMIN || authInfo.role === SYSTEM_ROLE.MANAGER) &&(
            <React.Fragment>
              <div>
                <ItemShowInfo title={t('label.companiesAccounts')} color="#fff" backgroundColor="#f79007" icon={<BusinessIcon />} value={numberOfCompanies} />
              </div>
              <Box style={{ margin: '15px 0' }}>
                <HighchartsReact
                  highcharts={Highcharts}
                  options={adminOptions}
                />
              </Box>
              <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                <div style={styles.noteChartContainer}>
                  <div style={styles.noteChartRow}>
                    <div style={{ ...styles.noteChartColor, backgroundColor: colorColumns.threeMonths }} />
                    <span style={styles.noteChartLabel}>{t('label.3months')}</span>
                  </div>
                  <div style={styles.noteChartRow}>
                    <div style={{ ...styles.noteChartColor, backgroundColor: colorColumns.sixMonths }} />
                    <span style={styles.noteChartLabel}>{t('label.6months')}</span>
                  </div>
                  <div style={styles.noteChartRow}>
                    <div style={{ ...styles.noteChartColor, backgroundColor: colorColumns.oneYear }} />
                    <span style={styles.noteChartLabel}>{t('label.1year')}</span>
                  </div>
                </div>
              </div>
            </React.Fragment>
          )
        }
        {
          authInfo.role === SYSTEM_ROLE.COMPANY
          && (
            <React.Fragment>
              <Grid container spacing={3} style={{ justifyContent: isMobile ? 'center' : 'flex-start'}}>
                <Grid item>
                  <ItemShowInfo title={t('label.participantAccounts')} color="#fff" backgroundColor="#f04337" icon={<PeopleIcon />} value={numberOfClients} />
                </Grid>
                <Grid item>
                  <ItemShowInfo title={t('label.workerAccounts')} color="#fff" backgroundColor="#6366f1" icon={<PeopleOutlineIcon />} value={numberOfWorkers} />
                </Grid>
                <Grid item>
                  <ItemShowInfo title={t('label.bookings')} color="#fff" backgroundColor="#f79007" icon={<EventAvailableIcon />} value={numberOfBookings} />
                </Grid>
                <Grid item>
                  <ItemShowInfo title={t('label.payrolls')} color="#fff" backgroundColor="#11b981" icon={<AttachMoneyIcon />} value={numberOfPayrolls} />
                </Grid>
                <Grid item>
                  <ItemShowInfo title={t('label.billings')} color="#fff" backgroundColor="#c75eff" icon={<i className="fas fa-file-invoice-dollar" />} value={numberOfBillings} />
                </Grid>
              </Grid>
              {!isMobile && <Grid container>
                <Grid item sm={isMobile ? 12 : 6} md={isMobile ? 12 : 6}>
                  <Box style={{ margin: '15px 0' }}>
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={authInfo.role === SYSTEM_ROLE.COMPANY ? options : adminOptions}
                      // containerProps={[
                      //   className: classes.customHighchart
                      // ]}
                    />
                  </Box>
                  <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                    <div style={styles.noteChartContainer}>
                      <div style={styles.noteChartRow}>
                        <div style={{ ...styles.noteChartColor, backgroundColor: colorColumns.threeMonths }} />
                        <span style={styles.noteChartLabel}>{t('label.3months')}</span>
                      </div>
                      <div style={styles.noteChartRow}>
                        <div style={{ ...styles.noteChartColor, backgroundColor: colorColumns.sixMonths }} />
                        <span style={styles.noteChartLabel}>{t('label.6months')}</span>
                      </div>
                      <div style={styles.noteChartRow}>
                        <div style={{ ...styles.noteChartColor, backgroundColor: colorColumns.oneYear }} />
                        <span style={styles.noteChartLabel}>{t('label.1year')}</span>
                      </div>
                    </div>
                  </div>
                </Grid>
                <Grid item sm={isMobile ? 12 : 6} md={isMobile ? 12 : 6}>
                  <Box style={{ margin: '15px 0' }}>
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={options2}
                    />
                  </Box>
                  <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                    <div style={styles.noteChartContainer}>
                      <div style={styles.noteChartRow}>
                        <div style={{ ...styles.noteChartColor, backgroundColor: colorColumns.oneWeek }} />
                        <span style={styles.noteChartLabel}>{t('label.1week')}</span>
                      </div>
                      <div style={styles.noteChartRow}>
                        <div style={{ ...styles.noteChartColor, backgroundColor: colorColumns.twoWeeks }} />
                        <span style={styles.noteChartLabel}>{t('label.2weeks')}</span>
                      </div>
                      <div style={styles.noteChartRow}>
                        <div style={{ ...styles.noteChartColor, backgroundColor: colorColumns.threeWeeks }} />
                        <span style={styles.noteChartLabel}>{t('label.3weeks')}</span>
                      </div>
                    </div>
                  </div>
                </Grid>
              </Grid>}
              {isMobile && <React.Fragment>
                <Box style={{ margin: '15px 0' }}>
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={authInfo.role === SYSTEM_ROLE.COMPANY ? options : adminOptions}
                      // containerProps={[
                      //   className: classes.customHighchart
                      // ]}
                    />
                  </Box>
                  <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                    <div style={styles.noteChartContainer}>
                      <div style={styles.noteChartRow}>
                        <div style={{ ...styles.noteChartColor, backgroundColor: colorColumns.threeMonths }} />
                        <span style={styles.noteChartLabel}>{t('label.3months')}</span>
                      </div>
                      <div style={styles.noteChartRow}>
                        <div style={{ ...styles.noteChartColor, backgroundColor: colorColumns.sixMonths }} />
                        <span style={styles.noteChartLabel}>{t('label.6months')}</span>
                      </div>
                      <div style={styles.noteChartRow}>
                        <div style={{ ...styles.noteChartColor, backgroundColor: colorColumns.oneYear }} />
                        <span style={styles.noteChartLabel}>{t('label.1year')}</span>
                      </div>
                    </div>
                  </div>
                  <Box style={{ margin: '15px 0' }}>
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={options2}
                    />
                  </Box>
                  <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                    <div style={styles.noteChartContainer}>
                      <div style={styles.noteChartRow}>
                        <div style={{ ...styles.noteChartColor, backgroundColor: colorColumns.oneWeek }} />
                        <span style={styles.noteChartLabel}>{t('label.1week')}</span>
                      </div>
                      <div style={styles.noteChartRow}>
                        <div style={{ ...styles.noteChartColor, backgroundColor: colorColumns.twoWeeks }} />
                        <span style={styles.noteChartLabel}>{t('label.2weeks')}</span>
                      </div>
                      <div style={styles.noteChartRow}>
                        <div style={{ ...styles.noteChartColor, backgroundColor: colorColumns.threeWeeks }} />
                        <span style={styles.noteChartLabel}>{t('label.3weeks')}</span>
                      </div>
                    </div>
                  </div>
                </React.Fragment>}
            </React.Fragment>
          )
        }

      </Box>
    </Box>
  );
};

export default DashboardPage;